import { useState } from "react";
import { updateLandAcquisitionRequest } from "../../store/actions/adminActions";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

export function useLandAcquisitionActions() {
    const dispatch = useDispatch();
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showCommentsModal, setShowCommentsModal] = useState(false);
    const [processingAction, setProcessingAction] = useState(false);
    const [comments, setComments] = useState("");

    const handleViewDetails = (request) => {
        setSelectedRequest(request);
        setShowDetailsModal(true);
    };

    const handleUpdateStatus = async (action) => {
        setProcessingAction(true);

        let payload = {
            requestId: selectedRequest._id,
            action,
        };

        if (action === "rejected") {
            payload.rejectionReason = comments;
        }

        dispatch(updateLandAcquisitionRequest(payload))
            .then(() => {
                Swal.fire({
                    icon: "success",
                    title: `Request ${action.charAt(0).toUpperCase() + action.slice(1)}`,
                    text: action === "approve"
                        ? "Land acquisition request approved successfully"
                        : "Land acquisition request rejected successfully"
                });
                setShowDetailsModal(false);
                setShowCommentsModal(false);
                setSelectedRequest(null);
                setComments("");

            })
            .catch(error => {
                Swal.fire({
                    icon: "error",
                    title: "Update Failed",
                    text: error.message || "Failed to update withdrawal request"
                });
            })
            .finally(() => {
                setProcessingAction(false);
            });
    };

    const initiateApproval = () => {
        handleUpdateStatus("approve");
    };

    const initiateRejection = () => {
        setShowCommentsModal(true);
    };

    const closeModals = () => {
        setShowDetailsModal(false);
        setShowCommentsModal(false);
        setSelectedRequest(null);
        setComments("");
    };

    return {
        selectedRequest,
        showDetailsModal,
        showCommentsModal,
        processingAction,
        comments,
        setComments,
        setShowCommentsModal,
        handleViewDetails,
        handleUpdateStatus,
        initiateApproval,
        initiateRejection,
        closeModals
    };
}